import Box from '@mui/material/Box'
import { resolveSurveyMediaUrl } from '../../../lib/resolve-survey-media-url'
import type { SurveyQuestion } from '../../../lib/survey-question.types'
import { ShortTextQuestion } from './ShortTextQuestion'
import { VideoPlaybackEmbed } from './VideoPlaybackEmbed'

interface VideoQuestionProps {
  readonly question: SurveyQuestion
  readonly value: string | null
  readonly onChange: (value: string) => void
}

/** Video stimulus + short-text response (MVP). Playback stays inside Brushfire. */
export function VideoQuestion({ question, value, onChange }: VideoQuestionProps) {
  const playbackUrl = resolveSurveyMediaUrl(question.videoUrl) ?? question.videoUrl ?? ''

  return (
    <Box data-testid={`survey-q-${question.id}-video`} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <VideoPlaybackEmbed videoUrl={playbackUrl} testId={`survey-q-${question.id}-video-player`} />
      <ShortTextQuestion question={question} value={value} onChange={onChange} />
    </Box>
  )
}
